module.exports = __webpack_public_path__ + "static/elephants-dream-d9bb91c39d188f99879965c4363f5dc4.webm";